/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import { compose, withReducer, renderComponent, withHandlers, mapProps, branch } from 'recompose';
import LoadingSpinner from '../Spinners/LoadingSpinner.js';

export const LOAD = '@@list/LOAD';
export const RESET = '@@list/RESET';
export const FILTER = '@@list/FILTER';
export const EXPAND_ALL = '@@list/EXPAND_ALL';
export const COLLAPSE_ALL = '@@list/COLLAPSE_ALL';
export const TOGGLE = '@@list/TOGGLE';

export const initialState = {
  filterState: '',
  buckets: [],
  bucketStates: [],
};

const reducer = (state=initialState, action) => {
  switch (action.type) {
    case FILTER: {
      return {
        ...state,
        filterState: action.filterState
      };
    }
    case TOGGLE: {
      const { bucketStates } = state;
      const newState = !bucketStates[action.index];
      return {
        ...state,
        bucketStates: [...bucketStates.slice(0, action.index), newState, ...bucketStates.slice(action.index+1)]
      };
    }
    case EXPAND_ALL: {
      return {
        ...state,
        bucketStates: state.bucketStates.map(() => true)
      };
    }
    case COLLAPSE_ALL: {
      return {
        ...state,
        bucketStates: state.bucketStates.map(() => false)
      };
    }
    default: {
      return state;
    }
  }
};

const connect = (columns, buckets, filter, sort) => compose(
  branch(
    (props) => !Boolean(props.rows),
    renderComponent(LoadingSpinner)
  ),
  withReducer('bucketedList', 'dispatch',
    reducer,
    (props) => ({
      filterState: '',
      bucketStates: buckets.map((b) => b.open || false)
    })
  ),
  withHandlers(() => ({
    filter: ({ dispatch }) => (filterState) => dispatch({
      type: FILTER,
      //name,
      filterState,
    }),
    toggle: ({ dispatch }) =>  (index) => dispatch({
      type: TOGGLE,
      //name,
      index,
    }),
    expandAll: ({ dispatch }) =>  () => dispatch({
      type: EXPAND_ALL,
      //name,
    }),
    collapseAll: ({ dispatch }) =>  () => dispatch({
      type: COLLAPSE_ALL,
      //name,
    }),
  })),
  mapProps(
    (props) => {
      const filteredRows = props.rows.filter((row) => filter(row, props.bucketedList.filterState));
      filteredRows.sort(sort);
      return {
        bucketedList: {
          actions: {
            filter: props.filter,
            expandAll: props.expandAll,
            collapseAll: props.collapseAll
          },
          buckets: buckets.map((bucket, i) => {
            const _rows = bucket.partition(filteredRows);
            const _title = bucket.title(_rows);
            return {
              rows: _rows,
              title: _title,
              open: props.bucketedList.bucketStates[i],  
              toggle: () => props.toggle(i)
            };
          }),
          columns,
        }
      };
    }
  )
);


export default connect;
